import React from 'react';
import { array, func, string } from 'prop-types';
import useStyles from 'hooks/useStyles';

import Button from 'components/Button';
import { CheckIcon } from 'components/Icon';

import styles from './Notebook.scss';

function Notebook({
  title,
  features,
  coverUrl,
  contactUrl,
  onButtonClick,
  buttonText,
}) {
  useStyles(styles);

  const openContactUrl = () => window.open(contactUrl);

  const renderCTAButton = () => {
    if (onButtonClick)
      return (
        <Button type="primary" onClick={onButtonClick} text={buttonText} />
      );

    return (
      contactUrl && (
        <Button type="primary" onClick={openContactUrl} text={buttonText} />
      )
    );
  };

  return (
    <div className={styles.root}>
      <h3 className={styles.heading}>{title}</h3>
      <div className={styles.content}>
        <ul className={styles.list}>
          {features.map((feature, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li className={styles.item} key={`${feature}-${index}`}>
              <CheckIcon className={styles.icon} width={24} height={24} />
              <div>{feature}</div>
            </li>
          ))}
        </ul>
        {renderCTAButton()}
      </div>

      {coverUrl && (
        <div className={styles.figure}>
          <img src={coverUrl} alt={title} />
        </div>
      )}
    </div>
  );
}

Notebook.propTypes = {
  title: string.isRequired,
  features: array.isRequired,
  coverUrl: string.isRequired,
  buttonText: string.isRequired,
  contactUrl: string,
  onButtonClick: func,
};

Notebook.defaultProps = {
  contactUrl: '',
  onButtonClick: undefined,
};

export default Notebook;
